import Btn from '../elements/Btn';
import Hero from '../elements/Hero'
import Title from '../elements/Title'
import HeroBanner from '../img/whyus.png';
import Newsletter from '../elements/Newsletter';
import Footer from '../elements/Footer';
import FreeQuote from '../elements/FreeQuote';
import ContactSection from '../elements/ContactSection';
export default function Contact() {
  return <>
    <Hero bg={HeroBanner} clsName="junkbanner_sec">
        <div className='pt-3 pt-sm-4 pt-lg-5 bannerTri junk_banner' >
            <div className='row' >
                <div className='col-md-12 pb-5 mt-3' >
                    <div className='banner_content py-0 pt-4' >
                        <Title mainClass="text-center"
                            titleclass="lg text-white mb-2"
                            desclass="text-center mt-3 mb-3 mb-sm-5"
                            title={<>Get In Touch</>}
                            des="Already Using Exquisite Moves? Sign In So We Can Tailor Your Support Experience. If That’s Not Possible, We’d Still Like To Hear From You!" />
                        <Btn class="mb-4 m-auto d-table"
                            arrow={true}
                            wave={true}
                            href="#"
                        >Contact Us</Btn>
                    </div>
                </div>
            </div>
        </div>
    </Hero>
    <ContactSection />
    <FreeQuote />
    <Newsletter />
    <Footer />
  </>
}
